import StatusItem, {typesOfData} from "./StatusItem";

export class StatusItemConditions extends StatusItem {
    constructor(dataObject) {
        super(dataObject)
        this.itemType = typesOfData.condition
    }

    get indicatorMax() {
        return 5
    }

    get indicatorCurrent() {
        return this.state
    }

    get result() {
        switch (this.state) {
            case 1:
                return 'Mycket slitet skick 1/5'
            case 2:
                return 'Slitet skick 2/5'
            case 3:
                return 'Helt OK skick 3/5'
            case 4:
                return 'Bra skick 4/5'
            case 5:
                return 'Mycket bra skick 5/5'
            default:
                return 'Okänt skick'
        }
    }
}